var e = {};
export {
  e as __exports
};
//# sourceMappingURL=index.es310.js.map
